import { Component } from 'shimmer'

import {
  PlaneGeometry,
  MeshNormalMaterial,
  MeshStandardMaterial,
  Mesh
} from 'three'

import { webGL } from '@/webGL/WebGL'

import { MeshReflectorMaterial } from '@/webGL/materials/MeshReflectorMaterial'

import { gui } from '@/utils/gui'

export class Floor extends Component {
  constructor () {
    super()

    this.object = new Mesh(new PlaneGeometry(65, 65))
    this.object.material = new MeshReflectorMaterial(webGL.renderer.renderer, webGL.camera, webGL.scene, this.object, {
      resolution: 1024,
      blur: [512, 128],
      mixBlur: .6,
      mixContrast: 1,
      mixStrength: 1.7,
      mirror: .4
    })
    this.object.rotation.x = -Math.PI * .5
    this.object.position.y = 0.3

    this.object.material.transparent = true
    this.object.material.opacity = .5

    this.add(this.object)
    this.addGui()
  }

  onUpdate() {
    this.object.material.update()
  }

  addGui () {
    const folder = gui.addFolder('Reflector')
    folder.add(this.object.material, 'opacity', 0, 1, .01)
    folder.add(this.object.material.reflectorProps, 'mixBlur', 0, 5, .01)
    folder.add(this.object.material.reflectorProps, 'mixContrast', 0, 2, .01)
    folder.add(this.object.material.reflectorProps, 'mixStrength', 0, 5, .01)
    folder.add(this.object.material.reflectorProps, 'mirror', 0, 2, .01)
  }
}